import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFilePerformanceConfig } from '@v2/pages/nc-file/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsNCFilePerformanceStack = createStackNavigator();

const NCFileDetailsNCFilePerformanceNavigator = () => {
  return (
    <NCFileDetailsNCFilePerformanceStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFilePerformanceConfig.map(({ Component, name }) => (
        <NCFileDetailsNCFilePerformanceStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileDetailsNCFilePerformanceStack.Navigator>
  );
};

export { NCFileDetailsNCFilePerformanceNavigator };
